type EnvironmentValiablesEntity = {
    ClientID : string,
    Client_Secret : string
}

export const EnvironmentValiables : EnvironmentValiablesEntity = {
    ClientID : '1E98A5E3-8CF0-445F-8399-76975DEE375F',
    Client_Secret : 'wrP9cOqV3f88bog8gjK9BQ=='
}
